import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Login from "./components/Login/Login.js";
import Reepay from "./components/Login/Reepay.js";
import ForgotPassword from "./components/Login/ForgotPassword.js";
import ResetPassword from "./components/Login/ResetPassword.js";
import Unsubscribe from "./components/Contact/Unsubscribe.js";
import Register from "./components/Login/Register.js";
import Admin from "./components/Login/Admin.js";
import { MuiThemeProvider } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import Analytics from "./Analytics.js";
import Newsletter from "./components/Admin/Newsletter.js";
import Companies from "./components/Admin/Companies.js";
import OnlineBooking from "./components/OnlineBooking/OnlineBooking.js";
import PrimaryLayoutRoute from "./layouts/PrimaryLayoutRoute.js";
import SelectPlan from "./components/SelectPlan/SelectPlan.js";
import { PatientPersonalInformationForm } from "./components/Calendar/index.js";

const theme = createMuiTheme({
    palette: {
        primary: { main: "#4d5ccc" },
        secondary: {
            light: "#ff7961",
            main: "#f44336",
            dark: "#ba000d",
            contrastText: "#fff"
        },
        default: {
            main: "#343434",
            contrastText: "#fff"
        }
    }
});

const App = props => {
    return (
        <MuiThemeProvider theme={theme}>
            <Router>
                <Route
                    render={props => (
                        <Analytics history={props.history}>
                            <Switch>
                                <PrimaryLayoutRoute
                                    path="/companies"
                                    id="companies"
                                    classes="companies"
                                    collapsed
                                    hideBreadcrumbs
                                    component={Companies}
                                />
                                <Route path={["/register"]} exact component={Register} />
                                <Route path={["/forgot_password"]} exact component={ForgotPassword} />
                                <Route path={["/reset_password"]} exact component={ResetPassword} />
                                <Route path={["/unsubscribe"]} exact component={Unsubscribe} />
                                <Route path={["/Newsletter"]} exact component={Newsletter} />
                                <Route path={["/admin"]} exact component={Admin} />
                                <Route path={["/SelectPlan"]} exact component={SelectPlan} />
                                <Route path={["/OnlineBooking"]} exact component={OnlineBooking} />
                                <Route path={["/reepay"]} exact component={Reepay} />
                                PatientPersonalInformationForm
                                <Route
                                    path={"/patientPersonalInformationForm"}
                                    component={PatientPersonalInformationForm}
                                />
                                <Route path={["/"]} component={Login} />
                            </Switch>
                        </Analytics>
                    )}
                />
            </Router>
        </MuiThemeProvider>
    );
};

export default App;
